/* eslint-disable import/order */
import '@/@iconify/icons-bundle'
import '@/@iconify/nav-icons'
import App from '@/App.vue'
import ability from '@/plugins/casl/ability'
import { installChunkLoadRecovery } from '@/plugins/chunkLoadRecovery'
import i18n from '@/plugins/i18n'
import layoutsPlugin from '@/plugins/layouts'
import RollbarPlugin from '@/plugins/rollbar' // Path to your rollbar.js file
import vuetify from '@/plugins/vuetify'
import { loadFonts } from '@/plugins/webfontloader'
import router from '@/router'
import { abilitiesPlugin } from '@casl/vue'
import '@core/scss/template/index.scss'
import '@styles/styles.scss'
import { createHead } from '@unhead/vue/client'
import { createPinia } from 'pinia'
import { createApp } from 'vue'

import Vue3Toastify from 'vue3-toastify'

installChunkLoadRecovery()

// The font loader is a lazy chunk too; a failed fetch is handled by the chunk-load recovery above
// and must not also surface as an unhandled rejection.
loadFonts().catch(() => undefined)

// Create vue app
const app = createApp(App)
const head = createHead()

// Close drawer when using broser history
window.addEventListener('popstate', () => {
  const currentRouteQuery = router.currentRoute.value.query

  if (currentRouteQuery && currentRouteQuery.id) {
    // openDrawer();
  } else if (Object.keys(currentRouteQuery).length) {
    router.replace({
      path: router.currentRoute.value.path,
    })
  }
})

// Use plugins
app.use(vuetify)
app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(layoutsPlugin)
app.use(head)
app.use(abilitiesPlugin, ability, {
  useGlobalProperties: true,
})
app.use(Vue3Toastify, {
  autoClose: 3000,
  clearOnUrlChange: false,
})

app.use(RollbarPlugin)

// Wait for the router's initial navigation to resolve before mounting, so the
// first paint already has the correct route meta (layout) instead of briefly
// rendering with Vue Router's empty-meta placeholder route.
router.isReady().then(() => {
  app.mount('#app')
})
